import CampaignCalloutsServiceClient from './src-clients-campaign-callouts-service-client.js';

const getCampaignCalloutsByLocale = async (allExperiments, tenant, culture, previewDate) => {
  return new CampaignCalloutsServiceClient().getCalloutsByLocale(tenant, culture, allExperiments, previewDate);
};

export { getCampaignCalloutsByLocale };
//# sourceMappingURL=src-utils-index.js.map
